import * as React from 'react'

import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import cn from 'classnames'

import DarkDropdown from './dark-dropdown.svg'
import Dropdown from './dropdown.svg'
import classes from './FaqAccordion.module.scss'

const RICH_DATA_STRINGS = {
  FAQ_ITEM_PROP: 'mainEntity',
  QUESTION_ITEM_TYPE: 'https://schema.org/Question',
  ANSWER_ITEM_TYPE: 'https://schema.org/Answer',
  ANSWER_ITEM_PROP: 'acceptedAnswer',
  TEXT_ITEM_PROP: 'text',
}

interface FaqAccordionProps {
  children: React.ReactNode
  title: string
  id: string
  dataTestId?: string
  dataItemName?: string
  darkText?: boolean
}

export const FaqAccordion = ({
  children,
  title,
  id,
  dataTestId,
  dataItemName,
  darkText = false,
}: FaqAccordionProps) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleClick = () => setIsOpen(!isOpen)

  return (
    <div
      itemScope
      itemProp={RICH_DATA_STRINGS.FAQ_ITEM_PROP}
      itemType={RICH_DATA_STRINGS.QUESTION_ITEM_TYPE}
      className={cn(classes.root, darkText && classes.darkText)}
    >
      <button
        onClick={handleClick}
        aria-expanded={isOpen}
        aria-controls={id}
        id={`label-${id}`}
        className={cn(classes.button, darkText && classes.darkText)}
        data-item-category={TRACKING_CATEGORIES.NAVIGATION}
        data-item-name={dataItemName}
      >
        <h3
          data-testid={dataTestId}
          itemProp="name"
          className={classes.heading}
        >
          {title}
        </h3>
        <span className={cn(classes.arrow, isOpen && classes.open)}>
          <img src={darkText ? DarkDropdown : Dropdown} alt="" />
        </span>
      </button>
      <div
        id={id}
        aria-labelledby={`label-${id}`}
        hidden={!isOpen}
        itemScope
        itemProp={RICH_DATA_STRINGS.ANSWER_ITEM_PROP}
        itemType={RICH_DATA_STRINGS.ANSWER_ITEM_TYPE}
        className={classes.content}
      >
        <div itemProp={RICH_DATA_STRINGS.TEXT_ITEM_PROP}>{children}</div>
      </div>
    </div>
  )
}

export default FaqAccordion
